import { Typography } from "@mui/material"

import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { ConfirmModal } from "../../../../../../../shared/components/dialogs/ConfirmModal"

export enum DayConfirmAction {
    CLOSE_DAY = "CLOSE_DAY",
    REMOVE_THEME = "REMOVE_THEME",
}

type Props = Readonly<{
    open: boolean
    action: DayConfirmAction
    /** Started dishes on the day, shown in the close-day message. */
    filledCount: number
    onConfirm: () => void
    onClose: () => void
}>

/** Confirms day actions that affect existing content: closing a filled day or removing a filled theme. */
export function DayConfirmDialog({ open, action, filledCount, onConfirm, onClose }: Props) {
    const isCloseDay = action === DayConfirmAction.CLOSE_DAY

    return (
        <LocalizedStrict
            id={isCloseDay ? "merchant-week-menu-close-day-dialog" : "merchant-week-menu-remove-theme-dialog"}
            attrs={{ title: true, buttonLabelSubmit: true }}
        >
            <ConfirmModal
                open={open}
                onClose={onClose}
                handleClick={onConfirm}
                title="Close this day"
                message={
                    isCloseDay ? (
                        <LocalizedStrict id="merchant-week-menu-close-day-dialog-message" vars={{ count: filledCount }}>
                            <Typography variant="body1">
                                {filledCount} filled dishes on this day will not be published while it is closed.
                            </Typography>
                        </LocalizedStrict>
                    ) : (
                        <LocalizedStrict
                            id="merchant-week-menu-remove-theme-dialog-message"
                            vars={{ count: filledCount }}
                        >
                            <Typography variant="body1">
                                Discard the theme dishes on this day and switch back to the template?
                            </Typography>
                        </LocalizedStrict>
                    )
                }
                buttonLabelSubmit="Close day"
            />
        </LocalizedStrict>
    )
}
